import AppHeader from "@/components/AppHeader";

export default {
  name: "master-company",
  components: {
    AppHeader
  },
  created() {
    this.getCompany();
  },
  data() {
    return {
      companies: "",
      getCompanisEnd: false
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    }
  }
};
